import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "BancoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "EspecialidadPage",
            ss: ss,
            ajax: {
                "url": ss.indexEspecialidad(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Especialidad', name: 'Especialidad', title: 'Especialidad' },
                { data: 'Codigo', name: 'Codigo', title: 'Código' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            especialidades: [],
            especialidad: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newEspecialidad() {
            this.especialidad = {};
            this.$refs['frm-especialidad'].show();
        },
        showEspecialidad(id) {
            this.isLoading=true;
            this.ss.showEspecialidad(id).then(
                (result) => {
                    let response = result.data;
                    this.especialidad = response.data;
                    this.$refs['view-especialidad'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editEspecialidad() {
            this.$refs['frm-especialidad'].show();
            this.$refs['view-especialidad'].hide();
        },
        cancelEspecialidad() {
            if (this.especialidad.id) {
                this.$refs['view-especialidad'].show();
            }
            this.$refs['frm-especialidad'].hide();
        },
        saveEspecialidad() {
            this.ss.storeEspecialidad(this.especialidad).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-especialidad'].hide();
                    this.$refs['datatable-especialidad'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEspecialidad() {
            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "¿Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyEspecialidad(this.especialidad)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-especialidad'].hide();
                                this.$refs['datatable-especialidad'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Especialidad').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEspecialidad(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
